import { FrameName } from "@/game/entities/config";
import EventTileEntity from "@/game/entities/EventTileEntity";
import { EventCategory } from "@/types/ui";

class CorsairShipBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.PIRATES;

	public static readonly frameName = FrameName.CORSAIR_SHIP;
}

export default CorsairShipBuildingTileEntity;
